export const changesOrders = ( status ) => {
    
    if (status == '5' || status == '50' || status == '51' || status == '53' || status == '54') {
        return true;
    } else {
        return false;
    }
    
}